module.exports = __webpack_public_path__ + "static/media/theodorojr.b8929c96.svg";